<template>
	<div>
		<!-- toasts message -->
		<Snackbar :SnackbarVal="SnackbarVal" ref="loader"></Snackbar>
		<!-- /toasts message -->

		<v-card-actions>
			<v-alert v-if="total_disburs < 1 && loanProfileData.is_old==0"
				:value="true"
				type="info"
				>
				Disbursement Amount is Empty!
			</v-alert>

			

			<v-spacer></v-spacer>	
			<v-btn color="primary" v-on:click="printdiv">
				<v-icon>print</v-icon> Print
			</v-btn>
			<v-btn color="warning" @click="downloadWithCSS">
				<v-icon>picture_as_pdf</v-icon> PDF
			</v-btn>
			<v-btn
				color="info"
				@click="exportTableToExcel('tblData', 'Repayment-Schedule')"
			>
				<v-icon>description</v-icon> Excel
			</v-btn>

			<v-btn color="error" @click="previous">
				<v-icon>arrow_back_ios</v-icon>Back
			</v-btn>

			
			
			

		</v-card-actions>
		 <div id="print-area">
		 	<div id="prescriptions_bgImgs">
		 		<div style="position: relative;">		 			
		 			<!-- <img :src="`${FrontendPath}/public/logo.png`"> -->
		 		</div>
		 	</div>
		 	<div ref="content">

		<table class="paySchedule" id="tblData">
           <!-- <table class="paySchedule" id="tblData"rules="groups" frame="hsides"> -->
           <colgroup align="center"></colgroup>
           <colgroup align="left"></colgroup>
           <colgroup span="2" align="center"></colgroup>
           <colgroup span="3" align="center"></colgroup>

			<tbody>
				<tr class="borderNone">
					<td colspan="7" style="color: #000000;text-align: center;font-size: 22px;font-weight: bold;">
						Investment Promotion and Financing Facility II (IPFF II) Project
					</td>
				</tr>
				<tr class="borderNone">
					<td colspan="7" style="color: #000000;text-align: center;font-size: 16px;font-weight: bold;">Repayment Schedule</td>
				</tr>
				
				<!-- ############ New ############ -->

				<tr class="borderNone">
					<td class="textAlignLeft">PFI Name : </td>
					<td colspan="6">
						{{loanProfileData.short_name}}
					</td>
				</tr>

				<tr class="borderNone">
					<td class="textAlignLeft">Borrower Name : </td>
					<td colspan="6">
						{{loanProfileData.sub_project_name}}
					</td>
				</tr>

				<tr>					
					<td class="textAlignLeft" >
						<template v-if="loanProfileData.reset_no > 0">
							Principal Amount
						</template>
						<template v-else>
							Disbursement Amount
						</template>
					</td>
					<td colspan="2" class="textRight"> {{loanProfileData.loan_amount | numberWithCommas}} </td>

					<td class="borderNone" ></td>

					<td colspan="2" class="textAlignLeft">No. of Installments</td>
					<td colspan="2" class="textRight">
						{{loanProfileData.no_of_installment}}
					</td>
				</tr>

				<tr>
					<td class="textAlignLeft">Interest Rate</td>
					<td colspan="2" class="textRight">
						{{loanProfileData.interest_rate}} %
					</td>
					<td class="borderNone"></td>
					<td colspan="2" class="textAlignLeft">Installment Frequency</td>
					<td colspan="2" class="textRight">
						{{loanProfileData.installment_type}}
					</td>
				</tr>

				<tr>
					<td class="textAlignLeft">Currency</td>
					<td colspan="2" class="textRight">
						{{loanProfileData.transaction_currency}}
					</td>
					<td class="borderNone"></td>
					<td colspan="2" class="textAlignLeft">
						<span>
							Grace Period (In Year)
						</span>					
					</td>
					<td colspan="2" class="textRight">
						<span>
							{{loanProfileData.grace_period_in_month /12}}
						</span>							
					</td>
				</tr>

				<tr>
					<td class="textAlignLeft">Loan No</td>
					<td colspan="2" class="textRight">
						{{loanProfileData.loan_no}}
					</td>
					<td class="borderNone"></td>
					<td colspan="2" class="textAlignLeft">Disbursement Date</td>
					<td colspan="2" class="textRight">
						<span>
						{{dateStringMonth(loanProfileData.disbursement_date)}}
						</span>
					</td>
				</tr>

				<tr>
					<td colspan="3" class="borderNone"></td>
					<td class="borderNone"> </td>
					<td colspan="2" class="textAlignLeft">
						{{ schedule_no_title }} 
					</td>
					<td colspan="2" class="textRight">
						<span>
						{{ schedule_no_value }}
						</span>
					</td>
				</tr>

				<tr>
					<td colspan="3" class="borderNone"></td>
					<td class="borderNone"> </td>
					<td colspan="2" class="textAlignLeft">
						{{ schedule_date_title }} 
					</td>
					<td colspan="2"  class="textRight">
						{{ schedule_date_value }}
					</td>
				</tr>

				<tr class="borderNone">
					<td colspan="7">&nbsp;<br></td>
				</tr>


			</tbody>
		</table>

		<table class="paySchedule" id="tblData">
            <thead>
              <tr class="tb-td">
                <td>INSTALLMENT NUMBER</td>
                <td>INSTALLMENT DATE</td>
                <td>OPENING PRINCIPAL</td>
                <td>INTEREST</td>
                <td>PRINCIPAL</td>
                <td>INSTALLMENT SIZE</td>
                <td>CLOSING PRINCIPAL</td>
              </tr>
            </thead>
            <tbody>
             <tr v-for="(val, i) in InstalmentData" :key="i" >
              <td class="textCenter" v-if="val.opening_principal != '-' ">{{ val.instNumber }}</td>
              <td class="textCenter" v-if="val.opening_principal != '-' ">{{ dateStringMonth(val.instDate) }}</td>
              <td class="textRight" v-if="val.opening_principal != '-' ">{{ val.opening_principal }}</td>
              <td class="textRight" v-if="val.opening_principal != '-' ">{{ val.interest }}</td>
              <td class="textRight" v-if="val.opening_principal != '-' ">{{ val.principal }}</td>
              <td class="textRight" v-if="val.opening_principal != '-' ">{{ val.instSize }}</td>
              <td class="textRight " v-if="val.opening_principal != '-' ">{{ val.closing_principal }}</td>
            </tr>

            <tr class="borderNone">
              <td colspan="7">&nbsp;<br></td>
            </tr>
            
            <tr>
              <td class="borderNone" colspan="7">Remarks : {{loanProfileData.remarks}}</td>
            </tr>

          </tbody>
        </table>

	</div>
		</div>
	</div>
</template>

<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas"

let commonService = require("../../../services/common.service");
let UtilService = require("../../../services/util.service");
import { FrontendPath } from "../../../vuex/api";
import ServerPath from '../../../server-path/server-path';

export default {
  
  data() {
    return {
      e1: 0,
      loanProfileData:'',
      InstalmentData:[],
      InstalmentSaveData:[],
      totalSchedule:0,
      total_disburs:0,
      total_dis_amount:0,
      reset_no:0,
      re_schedule_no:0,
      resetLoan:'no',
	  schedule_no_title:'',
      schedule_no_value:'',
      schedule_date_title:'',
      schedule_date_value:'',

      FrontendPath:FrontendPath,

      saveBtn:0,

      SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

      json_fields: {
            'INSTALLMENT NUMBER': 'instNumber',
            'INSTALLMENT DATE': 'instDate',
            'OPENING PRINCIPAL': 'opening_principal',
            'INTEREST':'interest',
            'PRINCIPAL':'principal',
            'INSTALLMENT SIZE':'instSize',
            'CLOSING PRINCIPAL':'closing_principal',            
        },

      json_data: [],
      json_meta: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],

    };
  },
  
  created() {
  	let root = this;
  	let loan_id = sessionStorage.getItem("loan_id");

  	commonService.getAllDataById(loan_id, "get-payment-schedule").then(res => {
  		root.SnackbarVal.color = 'success';

  		if(res.loanProfileData)
  		{
  			root.saveBtn = res.loanProfileData.status;
  		}
  		else
  		{
  			root.saveBtn = 0;
  		}
  		

  		if(res.status == 0)
  		{  			
  			//root.$router.push("/on-lending/loan-profile-stepform");
  			root.SnackbarVal.color = 'error';
  			root.SnackbarVal.message = res.message;
    		root.SnackbarVal.snackbar = true;    		
    		
  		}
  		else
  		{
  			if(!res.saveData.length)
  			{
  				root.$router.push("/on-lending/loan-profile");
  			}

			// Select 
			if(res.loanProfileData.re_schedule_date == '0000-00-00' && res.loanProfileData.reset_date == '0000-00-00'){
				this.schedule_no_title = 'Schedule No';
				this.schedule_no_value = "1";
				this.schedule_date_title = 'Schedule Date';
				this.schedule_date_value = this.dateStringMonth(res.loanProfileData.disbursement_date);
			}else if(res.loanProfileData.reset_date == '0000-00-00'){
				this.schedule_no_title = 'Re-Schedule No';
				this.schedule_no_value = res.loanProfileData.re_schedule_no;
				this.schedule_date_title = 'Re-Schedule Date';
				this.schedule_date_value = this.dateStringMonth(res.loanProfileData.re_schedule_date);
			}else{
				this.schedule_no_title = 'Interest Reset No';
				this.schedule_no_value = res.loanProfileData.reset_no;
				this.schedule_date_title = 'Interest Reset Date';
				this.schedule_date_value = this.dateStringMonth(res.loanProfileData.reset_date);
			}

  			root.loanProfileData = res.loanProfileData;
  			root.InstalmentData = res.scheduleData;
  			root.InstalmentSaveData = res.saveData;
  			root.totalSchedule = res.totalSchedule;
  			root.total_disburs = res.total_disburs;
  			root.total_dis_amount = (res.total_dis_amount > 0) ? res.total_dis_amount : res.scheduleData[0].opening_principal; 
  			root.resetLoan = res.resetLoan

  			root.json_data = res.scheduleData; 			
  		}
  		  		
  		
  	});
  },

  methods:{

    savePaymentSchedule() {

    	this.$refs.loader.loaderEnabled();

    	let root = this;    	
    	let formData = new FormData();

    	formData.append("loanProfileData", JSON.stringify(this.loanProfileData));
    	formData.append("InstalmentData", JSON.stringify(this.InstalmentSaveData));

    	commonService.insertFormData(formData, "loan-profile-detail").then(res => {
    
    		if (res.status == 1) {
    			this.saveBtn = 2; //for hide save btn
    		}
    		if (res.status == 0) {
    			this.SnackbarVal.color = 'error';
    		}
    		this.SnackbarVal.message = res.message;
    		this.SnackbarVal.snackbar = true;

    		setTimeout(function(){
    			root.$emit("emitForm3", 1);
    		},4000);
    	});
    },

    downloadWithCSS() {
      // //const doc = new jsPDF();
      // const doc = new jsPDF({
      //   orientation: "a4",
      //   // unit: "pt",
      //   format: [800, 1000],
      // });
      // /** WITH CSS */
      // var canvasElement = document.createElement("canvas");
      // html2canvas(this.$refs.content, { canvas: canvasElement }).then(function(
      //   canvas
      // ) {
      //   const img = canvas.toDataURL("image/jpeg", 0.8);
      //   //doc.addImage(img,'JPEG',0,20);
      //   doc.addImage(img, "JPEG", 10, 10);
      //   doc.save("sample.pdf");
      // });


      let loan_id = sessionStorage.getItem("loan_id");
      let all_Data = {
        loan_id : loan_id,
        schedule_no_title : this.schedule_no_title,
        schedule_no_value : this.schedule_no_value,
        schedule_date_title : this.schedule_date_title,
        schedule_date_value : this.schedule_date_value,
      };
      let query_Data = [JSON.stringify(all_Data)];
      //  (query_Data.InstalmentData = JSON.stringify(this.InstalmentData))
      let parameters = new URLSearchParams({ ...query_Data}).toString();
      let route = ServerPath.serverPath+'/loan-schedle-pdf?'+parameters;
      window.open(route, '_blank');
    },

    toFixedVal(val)
    {
        return Math.round(val).toLocaleString()+'.00';
    },

  	previous() {
       this.$store.commit("resetLoanProfile");
       this.$router.push("/on-lending/loan-profile");
    },

    printdiv: function () {
                this.printContentStatus = true;
                const divToPrint = document.getElementById("print-area");
                this.printContentStatus = false;
                const newWin = window.open("", "Print-Window");
                newWin.document.open();
                newWin.document.write(
                    '<style type="text/css">'+
                    'table.paySchedule{ width:100%; border-collapse: collapse; }'+
                    '.paySchedule td{ border:1px solid #000; padding: 6px; }'+
                    '.paySchedule tr.tb-td td{font-weight: bold; text-align:center;}'+
                    'td.textCenter{text-align: center;}'+
                    'td.textRight{text-align: right;}'+
                    '#prescriptions_bgImgs{position: absolute; left: 35%; background-repeat: no-repeat;'+
                    'background-position: center; background-size: cover; opacity: 0.1; top: 30%; }.paySchedule tr.borderNone td,.paySchedule td.borderNone{border:none !important;}'+
                    'table { page-break-inside:auto }' +
                    'tr    { page-break-inside:avoid; page-break-after:auto }' +
                    'td    { page-break-inside:avoid; page-break-after:auto }' +
                    'thead { display:table-header-group }' +
                    'tfoot { display:table-footer-group }' +
					"</style>"
                );
                newWin.document.write(
                    '<html><head><link rel="stylesheet" href="src/assets/css/style.css" type="text/css" /></head><body onload="window.print()">' +
                    divToPrint.innerHTML +
                    "</body></html>"
                );

                newWin.document.close();
                setTimeout(function () {
                    newWin.close();
                }, 3000);
            },



		exportTableToExcel: function(tableID, filename = ''){
			var downloadLink;
			var dataType = 'application/vnd.ms-excel';
			var tableSelect = document.getElementById(tableID);
			var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

			// Specify file name
			filename = filename?filename+'.xls':'excel_data.xls';

			// Create download link element
			downloadLink = document.createElement("a");

			document.body.appendChild(downloadLink);

			if(navigator.msSaveOrOpenBlob){
			var blob = new Blob(['\ufeff', tableHTML], {
			type: dataType
			});
			navigator.msSaveOrOpenBlob( blob, filename);
			}else{
			// Create a link to the file
			downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

			// Setting the file name
			downloadLink.download = filename;

			//triggering the function
			downloadLink.click();
			}
			}



  },

};
</script>

<style>
table.paySchedule{
	width:99%;
	border-collapse: collapse;
}
.paySchedule td{
	border:1px solid #000000;
	padding: 6px;
}
.paySchedule tr.tb-td td{
	font-weight: bold;
	text-align:center;
}
td.textCenter{
	text-align: center;
}
tr.textRight td,
td.textRight{
	text-align: right;
}
.paySchedule tr.borderNone td,
.paySchedule td.borderNone
{
	border:none !important;
}

.textAlignLeft {
	text-align: left;
}

#prescriptions_bgImgs{
	position: absolute; 
	left: 35%;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	opacity: 0.1;
	top: 30%;
}
</style>


// WEBPACK FOOTER //
// src/components/lending/loanProfile/reScheduleOnly.vue